import { AxisTickProps } from '@nivo/axes'
import { FinancialWorkspaceValueObjectsPeriodEnum } from 'generated/resources/graphql'

import { buildXAxis } from './helpers'

const Tick = (period?: FinancialWorkspaceValueObjectsPeriodEnum) => {
  const Component = ({ textAnchor, textX, textY, value, x, y }: AxisTickProps<string>) => {
    if (value === 'Start' || value === 'End') return <tspan />

    return (
      <g transform={`translate(${x},${y + 8})`}>
        <text
          fill="#515164"
          fontSize="12px"
          textAnchor={textAnchor}
          transform={`translate(${textX},${textY + 10})`}
        >
          <tspan>{buildXAxis(value, period)}</tspan>
        </text>
      </g>
    )
  }

  return Component
}

export { Tick }
